module.exports = __webpack_public_path__ + "img/non_inventory.32ff4aa7.png";